import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { updateShowExitIntentCookieBanner } from '../../visitor-identity/actions/updateShowExitIntentCookieBanner';
import { gdprCookieConsentOnExitIntentEnabled } from '../../utils/gdprCookieConsentPromptHelpers';
import { getAPIEnableWidgetCookieBannerOnExitIntent } from '../../widget-ui/selectors/getAPIEnableWidgetCookieBannerOnExitIntent';
export function declineCookies() {
  return (dispatch, getState) => {
    if (gdprCookieConsentOnExitIntentEnabled(getState()) || getAPIEnableWidgetCookieBannerOnExitIntent(getState())) {
      dispatch(updateShowExitIntentCookieBanner(false));
    }
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'clicked decline cookies button'
    }));
  };
}